import { Box, Button, Flex, HStack, Icon, Text } from "@chakra-ui/react";
import { FiFileText } from "react-icons/fi";

const ACCENT = "#4299E1";
const TITLE_ID = "final-estimate-review-bar-title";

type Props = {
  orderNo: string;
  onReviewEstimate: () => void;
  isLoading?: boolean;
};

/**
 * Bottom reminder while the OH looks at the enquiry after VIEW ENQUIRY (same
 * look as the ETA alert reminder banner): the final estimate review is still
 * pending and REVIEW ESTIMATE opens it again.
 */
const FinalEstimateReviewBar = ({
  orderNo,
  onReviewEstimate,
  isLoading = false,
}: Props) => (
  <Box
    data-eta-hard-lock-allow
    role="status"
    aria-labelledby={TITLE_ID}
    position="fixed"
    left={0}
    right={0}
    bottom={0}
    zIndex="popover"
    bg="white"
    borderTopWidth="3px"
    borderTopColor={ACCENT}
    boxShadow="0 -8px 24px rgba(0,0,0,0.22)"
    px={{ base: 3, md: 6 }}
    py={3}
    pointerEvents="auto"
  >
    <Flex
      align={{ base: "stretch", md: "center" }}
      justify="space-between"
      gap={3}
      direction={{ base: "column", md: "row" }}
      maxW="1200px"
      mx="auto"
    >
      <HStack spacing={3} align="flex-start" flex={1}>
        <Flex
          align="center"
          justify="center"
          w="36px"
          h="36px"
          borderRadius="full"
          bg={ACCENT}
          color="white"
          flexShrink={0}
        >
          <Icon as={FiFileText} boxSize={4} />
        </Flex>
        <Box>
          <Text id={TITLE_ID} fontWeight="bold" color="gray.800" fontSize="md">
            Final Estimate Review Pending · #{orderNo}
          </Text>
          <Text fontSize="sm" color="gray.600">
            Review the final estimate and mark it reviewed before it expires.
          </Text>
        </Box>
      </HStack>
      <HStack spacing={2} justify="flex-end">
        <Button
          bg={ACCENT}
          color="white"
          _hover={{ bg: ACCENT, opacity: 0.9 }}
          onClick={onReviewEstimate}
          isLoading={isLoading}
          h="40px"
          borderRadius="lg"
          minW="140px"
        >
          Review Estimate
        </Button>
      </HStack>
    </Flex>
  </Box>
);

export default FinalEstimateReviewBar;
